var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeta = function SvgMeta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 98 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.484 42.518c0 3.706.814 6.552 1.877 8.274 1.394 2.254 3.474 3.21 5.593 3.21 2.735 0 5.236-.679 10.056-7.346 3.862-5.343 8.412-12.843 11.473-17.546l5.185-7.966c3.602-5.532 7.77-11.682 12.55-15.851C61.122 1.89 65.33 0 69.567 0c7.112 0 13.887 4.122 19.072 11.851 5.674 8.466 8.429 19.13 8.429 30.134 0 6.542-1.29 11.348-3.484 15.146-2.12 3.672-6.251 7.342-13.202 7.342V54.002c5.951 0 7.437-5.469 7.437-11.727 0-8.918-2.08-18.815-6.66-25.887-3.25-5.016-7.463-8.08-12.098-8.08-5.013 0-9.047 3.78-13.58 10.52-2.41 3.582-4.884 7.947-7.662 12.872l-3.058 5.417c-6.144 10.893-7.7 13.374-10.772 17.469-5.384 7.17-9.981 9.887-16.034 9.887-7.18 0-11.72-3.11-14.531-7.794C1.127 52.86 0 47.85 0 42.144l10.484.374Z",
    fill: "#0081FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.59C12.807 5.182 19.744 0 27.7 0c4.607 0 9.188 1.364 13.97 5.27 5.233 4.27 10.81 11.3 17.766 22.889l2.495 4.158c6.022 10.032 9.448 15.194 11.453 17.627 2.579 3.126 4.385 4.058 6.73 4.058 5.952 0 7.437-5.469 7.437-11.727l9.249-.29c0 6.542-1.29 11.348-3.483 15.146-2.12 3.672-6.252 7.342-13.202 7.342-4.32 0-8.149-.939-12.382-4.932-3.254-3.065-7.058-8.51-9.985-13.404l-8.705-14.542c-4.368-7.298-8.375-12.74-10.694-15.203-2.494-2.65-5.7-5.85-10.818-5.85-4.142 0-7.66 2.906-10.603 7.352L8 12.59Z",
    fill: "url(#meta_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.797 10.542c-4.141 0-7.659 2.906-10.602 7.352-4.162 6.282-6.71 15.639-6.71 24.624 0 3.706.813 6.552 1.876 8.274l-8.938 5.886C1.127 52.861 0 47.852 0 42.145c0-10.38 2.849-21.199 8.267-29.553C13.073 5.18 20.01 0 27.967 0l-.17 10.542Z",
    fill: "url(#meta_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "meta_svg__a",
    x1: 13.471,
    y1: 39.494,
    x2: 86.493,
    y2: 43.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "meta_svg__b",
    x1: 15.19,
    y1: 46.92,
    x2: 15.19,
    y2: 22.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })))));
};
export default SvgMeta;